import type { CorridorPricingBadge as CorridorPricingBadgeData } from "@shared/corridorPricingBadge";
import classes from "@/components/ecosystem-head/CorridorPricingBadge.module.css";

type CorridorPricingBadgeProps = {
  badge: CorridorPricingBadgeData | null | undefined;
  size?: "xs" | "sm" | "md";
};

/** Free = light green pill; paid = gold pill. Hidden when badge is null/empty. */
export default function CorridorPricingBadge({ badge, size = "sm" }: CorridorPricingBadgeProps) {
  const label = badge?.label?.trim();
  if (!badge || !label) return null;

  const sizeClass = size === "xs" ? classes.xs : size === "md" ? classes.md : "";
  const variantClass = badge.variant === "free" ? classes.free : classes.paid;

  return (
    <span className={`${classes.pill} ${variantClass} ${sizeClass}`} title={label}>
      {label}
    </span>
  );
}
